/**
 * Check invalid chars
 * @param {object} e
 */
export let invalidChars = e => {
    const INVALID_CHARS = ['-', '+', 'e', '.', ','];
    if (INVALID_CHARS.includes(e.key)) {
      e.preventDefault();
      return true;
    }

    return false;
};



// WEBPACK FOOTER //
// invalidCharsChecker.js